import { useEffect } from "react";
import { toast } from "sonner";

export const DEMO_MSG = "Demo mode — view only";
const ACTION = /(^check-g|add|create|new-|edit|delete|remove|save|submit|approve|reject|send|upload|generate|assign|verify|mark|override|reset|toggle|move|advance|link|recheck|copy|confirm|signoff|images|status-select|assignee|password|email-btn|import)/i;
const SAFE = /(cancel|close|view|download|open|filter|search|tab|nav|logout|menu)/i;

function lock(root) {
  root.querySelectorAll("button, select, [role=menuitem], [role=combobox]").forEach((el) => {
    const id = el.getAttribute("data-testid") || "";
    const label = (el.textContent || "").trim();
    const isAction = (id && ACTION.test(id) && !SAFE.test(id.replace(/add-row|new-/g, ""))) || (!id && /^(add|save|submit|delete|send|approve|reject|create|upload)\b/i.test(label));
    if (!isAction || el.getAttribute("role") === "tab") return;
    if (!el.classList.contains("demo-locked")) {
      el.classList.add("demo-locked");
      el.setAttribute("aria-disabled", "true");
      el.setAttribute("title", DEMO_MSG);
    }
  });
}

export function DemoGuard() {
  useEffect(() => {
    lock(document.body);
    const obs = new MutationObserver(() => lock(document.body));
    obs.observe(document.body, { childList: true, subtree: true });
    const block = (e) => {
      if (e.type === "dragstart") { e.preventDefault(); toast.info(DEMO_MSG); return; }
      if (e.target.closest?.(".demo-locked")) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "click") toast.info(DEMO_MSG);
      }
    };
    const types = ["pointerdown", "mousedown", "click", "keydown", "submit", "dragstart"];
    types.forEach((t) => document.addEventListener(t, block, true));
    return () => { obs.disconnect(); types.forEach((t) => document.removeEventListener(t, block, true)); };
  }, []);
  return null;
}

export const DemoBadge = () => (
  <span className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full bg-amber-100 text-amber-800 border border-amber-200 whitespace-nowrap" data-testid="demo-mode-badge" title="All data is fictional. Actions are disabled.">
    <span className="sm:hidden">Demo</span><span className="hidden sm:inline">{DEMO_MSG}</span>
  </span>
);
